// app/javascript/projects/components/TranscriptCodePageContainer.jsx

import React from 'react';
import { useCodeDetails } from 'hooks/codes/queries';
import { useCodePageModal } from './contexts/CodePageModalContext';
import CodePageContainer from './CodePageContainer';

function TranscriptCodePageContainer({ projectID, hasEditPermission }) {
  const { isOpen, codeId, closeModal } = useCodePageModal();
  const { data: code, isLoading: codeLoading } = useCodeDetails(codeId);
  
  const show = isOpen && !codeLoading && !!code;
  
  return (
    <CodePageContainer
      codeID={codeId}
      projectID={projectID}
      hasEditPermission={hasEditPermission}
      show={show}
      hideModal={closeModal}
      codePage={false}
    />
  );
}

export default TranscriptCodePageContainer;
